// systemDatabasePurgeSession.js — suppress lazy database backfill while a type purge is running

const purgeCountsByBase = new Map();

function normalizeBaseKey(baseKey) {
  return String(baseKey || '').trim();
}

export function beginBaseTypePurge(baseKey) {
  const key = normalizeBaseKey(baseKey);
  if (!key) return;
  purgeCountsByBase.set(key, (purgeCountsByBase.get(key) || 0) + 1);
}

export function endBaseTypePurge(baseKey) {
  const key = normalizeBaseKey(baseKey);
  if (!key) return;
  const next = (purgeCountsByBase.get(key) || 0) - 1;
  if (next <= 0) {
    purgeCountsByBase.delete(key);
    return;
  }
  purgeCountsByBase.set(key, next);
}

export function isBaseTypePurgeInFlight(baseKey) {
  const key = normalizeBaseKey(baseKey);
  if (!key) return false;
  return (purgeCountsByBase.get(key) || 0) > 0;
}
